import {stringToDate} from "./Date";
import React, {Key, useEffect, useState} from "react";
import {
    DatePicker,
    DayOfWeek,
    defaultDatePickerStrings,
    IDatePicker,
    IDatePickerStyleProps, IDatePickerStyles,
    IStyleFunctionOrObject
} from "@fluentui/react";

export interface DateProps {
    isValid: boolean;
    isFutureDate: boolean;
    isPastDate?: boolean;
    value: Date | undefined | null;
    hasTypeDate?: boolean;
    dateString?: string;
    errorMessage?: string;
}

export interface DatePickerProps {
    date?: Date | undefined;
    resetFlag?: boolean;
    resetInitDate?: boolean;
    selectedDate?: string | undefined;
    // valid?: boolean;
    setSelectedDate?: any;
    isRequired?: boolean;
    datePickerKey?: Key | null | undefined;
    label?: string;
    initialPickerDate?: Date;
    ariaLabel?: string;
    placeholder?: string;
    className?: string;
    styles?: any;
    isOutOfBoundsErrorMessage?: string;
}

export interface DatePickerPropsOut {
    value: string | undefined;
    valid: boolean;
    message?: string;
}

export const FnpDatePicker = (props: DatePickerProps) => {

    const datePickerRef = React.useRef<IDatePicker>(null);
    const [datePickerValue, setDatePickerValue] = useState<Date | undefined>(props.date ? new Date(props.date) : undefined);

    const [changedDate, setChangedDate] = useState({
        date: new Date(),
        error: false,
        message: ''
    });
    let [dateString, setDateString] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (props.resetInitDate) {
            setDatePickerValue(undefined);
        }
    }, []);

    useEffect(() => {
        setDatePickerValue(undefined);
        setChangedDate({...changedDate, error: false, message: ''})
    }, [props.resetFlag]);

    const onChangeDate = (event: any) => {
        let typedDate = onParseDateFromString(dateString);
        let dateToChange;
        if (event !== typedDate) {
            dateToChange = event;
        } else {
            dateToChange = typedDate;
        }
        if (dateString && !typedDate) {
            setDatePickerValue(undefined);
            setChangedDate({...changedDate, error: true, message: 'Invalid date format'})
            let datePickerPropsOut: DatePickerPropsOut = {value: undefined, valid: false};
            props.setSelectedDate(datePickerPropsOut);
        } else {
            let date;
            if (!Number.isNaN(Date.parse(dateToChange))) {
                date = new Date(Date.parse(dateToChange));
            }
            let newDate = date === undefined ? undefined : new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
            setDatePickerValue(newDate);
            setChangedDate({...changedDate, error: false, message: ''})
            let datePickerPropsOut: DatePickerPropsOut = {value: newDate?.toLocaleDateString('fr-BE'), valid: true};
            props.setSelectedDate(datePickerPropsOut);
        }
        setDateString(undefined);
    }

    const onParseDateFromString = (newValue: string | undefined): Date | null => {
        if (newValue) {
            const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/\d{4}$/;
            if (dateRegex.test(newValue)) {
                const newValueParts = newValue.trim().split('/');
                const day = Math.max(1, Math.min(31, Number.parseInt(newValueParts[0], 10)));
                const month = Math.max(1, Math.min(12, Number.parseInt(newValueParts[1], 10))) - 1;
                let year = Number.parseInt(newValueParts[2], 10);
                let isFutureDate = new Date(year, month, day) > new Date();
                setChangedDate({
                    ...changedDate,
                    date: new Date(year, month, day),
                    error: isFutureDate,
                    message: isFutureDate ? 'Future dates are not permitted' : ''
                });

                // props.dateIsValid(!isFutureDate);
                let datePickerPropsOut: DatePickerPropsOut = {value: newValue, valid: !isFutureDate};
                setDatePickerValue(new Date(year, month, day));
                props.setSelectedDate(datePickerPropsOut);
                return new Date(year, month, day);
            }
        }
        return null;
    }

    return (
        <DatePicker
            key={props.datePickerKey}
            firstDayOfWeek={DayOfWeek.Monday}
            componentRef={datePickerRef}
            label={props.label}
            initialPickerDate={props.initialPickerDate}
            value={datePickerValue}
            placeholder={props.placeholder}
            formatDate={onFormatDate}
            className={props.className}
            onSelectDate={onChangeDate}
            maxDate={new Date()}
            isRequired={props.isRequired}
            textField={{
                onNotifyValidationResult: (errorMessage, value) => {
                    setDateString(value)
                },
                // errorMessage: changedDate.date && changedDate.error ? changedDate.message : !datePickerValue && props.isRequired ? "Field is required" : ""
                errorMessage: changedDate.date && changedDate.error ? changedDate.message : ""
            }}
            allowTextInput
            styles={{
                ...props.styles,
                statusMessage: {
                    display: 'none'
                }
            }}
            parseDateFromString={(dateStr: string) => {
                dateString = dateStr;
                return onParseDateFromString(dateStr);
            }}
            strings={{...defaultDatePickerStrings, isOutOfBoundsErrorMessage: props.isOutOfBoundsErrorMessage}}
        />
    );
}

export const onFormatDate = (date?: Date): string => {
    if (date) {
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let dayString = day < 10 ? '0' + day.toString() : day.toString();
        let monthString = month < 10 ? '0' + month.toString() : month.toString();

        return dayString + '/' + monthString + '/' + date.getFullYear();
    }

    return '';
};
export const onChangeDate = (date: Date | null | undefined, datePickerObj: DateProps): Date | undefined => {
    let typedDate = stringToDate(datePickerObj?.dateString);
    let dateToChange;
    let datePickerValue = undefined;
    if (date !== typedDate) {
        dateToChange = date;
    } else {
        dateToChange = typedDate;
    }
    if (datePickerObj?.dateString && !typedDate) {
        datePickerValue = undefined;
    } else {
        datePickerValue = dateToChange ?? undefined;
    }
    return datePickerValue;
}